import { getApiBaseUrl } from "../config/runtimeConfig";

const apiBaseUrl = getApiBaseUrl();

export class ApiError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

// Relatórios de rendas (Módulo 5 [5.5.x]) — camelCase pinado ao contrato do backend.

// [5.5.1] Receita de rendas por imóvel/período.
export interface RentRevenueRow {
  propertyId: number;
  propertyName: string;
  expectedTotal: number;
  receivedTotal: number;
  pendingTotal: number;
  noticeCount: number;
}

export interface RentRevenueReport {
  year: number;
  month: number | null;
  rows: RentRevenueRow[];
  totalExpected: number;
  totalReceived: number;
  totalPending: number;
}

// [5.5.2] Rentabilidade líquida por imóvel (receita recebida − IMI anual).
export interface PropertyProfitability {
  propertyId: number;
  propertyName: string;
  year: number;
  rentExpected: number;
  rentReceived: number;
  annualImi: number;
  netProfitability: number;
}

// [5.5.3] Incobrabilidade — rendas em atraso por período, por imóvel e inquilino.
export interface RentArrearsPropertyRow {
  propertyId: number;
  propertyName: string;
  overdueTotal: number;
  overdueCount: number;
}

export interface RentArrearsTenantRow {
  tenantId: number;
  tenantName: string;
  overdueTotal: number;
  overdueCount: number;
}

export interface RentArrearsReport {
  year: number;
  month: number | null;
  byProperty: RentArrearsPropertyRow[];
  byTenant: RentArrearsTenantRow[];
  totalOverdue: number;
  overdueCount: number;
}

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const response = await fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: "include",
  });

  if (!response.ok) {
    const text = await response.text();
    throw new ApiError(response.status, text || response.statusText);
  }

  return (await response.json()) as T;
}

export function getRentRevenueByProperty(
  year: number,
  month?: number,
): Promise<RentRevenueReport> {
  const search = new URLSearchParams({ year: String(year) });
  if (month != null && month > 0) {
    search.set("month", String(month));
  }
  return request<RentRevenueReport>(
    `/api/rent-reports/revenue-by-property?${search.toString()}`,
  );
}

export function getPropertyProfitability(
  propertyId: number,
  year: number,
): Promise<PropertyProfitability> {
  const search = new URLSearchParams({
    propertyId: String(propertyId),
    year: String(year),
  });
  return request<PropertyProfitability>(
    `/api/rent-reports/property-profitability?${search.toString()}`,
  );
}

export function getRentArrears(
  year: number,
  month?: number,
): Promise<RentArrearsReport> {
  const search = new URLSearchParams({ year: String(year) });
  if (month != null && month > 0) {
    search.set("month", String(month));
  }
  return request<RentArrearsReport>(
    `/api/rent-reports/arrears?${search.toString()}`,
  );
}
